export default __webpack_public_path__ + "static/media/exhibitors.590f0be1.jpg";